'use strict';

angular.module('docketbook')
  .controller('loadingController', function loadingController($scope, $state, accessControl) {
    // ensure current user
    accessControl.ensureCurrentUser().then(function (user) {
      let paramsTo = {};
      let stateTo = {};
      let searchParams = {};

      if ($state.params.goToParams) {
        paramsTo = JSON.parse($state.params.goToParams);
      }

      if ($state.params.searchParams) {
        searchParams = JSON.parse($state.params.searchParams);
        for (var paramKey in searchParams) {
          paramsTo[paramKey] = searchParams[paramKey];
        }
      }

      if ($state.params.goToState) {
        stateTo = JSON.parse($state.params.goToState);

        if (stateTo.params === null) {
          stateTo.params = {};
        }

        // copy the params over.
        const jsonParams = JSON.stringify(paramsTo);
        stateTo.params = JSON.parse(jsonParams);
      }

      // if redirectTo is present and the user is logged in, then proceed to redirect
      // to the url specified in the parameter.
      if ($state.params.redirectTo && $state.params.redirectTo !== '') {
        window.location = $state.params.redirectTo;
        return;
      }

      if (user.presignedToken != null && user.presignedTokenTarget != null) {
        let type = user.presignedTokenTarget.split(':')[0];
        let id = user.presignedTokenTarget.split(':')[1];

        $state.go('preauth.docket', { docketId: id, previewMode: true });

        return;
      } else if (stateTo.name === 'preauth.docket') {
        $state.go('main.docketDetail', { docketId: stateTo.params.docketId });

        return;
      } else {
        if (stateTo.name !== 'main.loading') {
          if (stateTo.name === 'main.dashboard') {
            const localStorageId = `orgGroup-${user.id}`;

            if (localStorage.getItem(localStorageId)) {
              const savedSessionOrgGroup = JSON.parse(localStorage.getItem(localStorageId));

              $state.go('main.groupDashboard', savedSessionOrgGroup);

              return;
            }
          }

          if (stateTo.params && stateTo.params.orgId) {
            accessControl.checkCompanyEnabled(stateTo.params.orgId, function (enabled) {
              if (enabled) {
                $state.go(stateTo.name, stateTo.params);
                return;
              } else {
                $state.go('main.groupDashboard', stateTo.params);
                return;
              }
            });
          } else if (stateTo.name === 'main.docketDetail') {
            $state.go('main.docketDetail', stateTo.params);
            return;
          } else {
            $state.go('main.dashboard', searchParams);
            return;
          }
        }

        $state.go('main.dashboard', searchParams);
      }
    }, function (err) {
      accessControl.logout($scope.urlVersion, $state.params.requestedUrl);
    });
  });



// WEBPACK FOOTER //
// ./src/controllers/loading.js